import { Outlet } from 'react-router-dom';
import Header from '../components/Header/Header';
import ChatBot from '../components/ChatBot/ChatBot';
import { useGroupData } from '../contexts/GroupDataContext';
import { isChatbotEnabledGroup } from '../utils/getDataGroupPath';
const HEADER_HEIGHT = 64;

const mainStyle = { height: `calc(100vh - ${HEADER_HEIGHT}px)` };

export default function ProtectedLayout() {
  const { groupData } = useGroupData();
  const chatbotEnabled = isChatbotEnabledGroup(groupData?.groupName);
  return (
    <div>
      <Header />
      <main style={mainStyle}>
        <Outlet />
      </main>
      {chatbotEnabled && <ChatBot />}
    </div>
  );
}
